import { cn } from '../../lib/cn';
import { Pill } from '../ui/Pill';
import { useInViewOnce } from '../../hooks/useInViewOnce';
import styles from './SectionHeader.module.css';

/**
 * The comp repeats one header shape everywhere: a pill eyebrow, a big
 * gradient-filled heading, and a muted subtitle.
 *
 * `actions` puts carousel controls on the right of the heading row; `as` lets a
 * page promote its header to <h1> without changing the visual scale.
 */
export function SectionHeader({
  eyebrow,
  title,
  subtitle,
  align = 'center', // 'center' | 'start'
  as: Tag = 'h2',
  actions,
  id,
  className,
}) {
  // One observer for the whole header rather than three nested Reveals; the
  // eyebrow, heading and subtitle stagger off a single class.
  const [ref, inView] = useInViewOnce();

  const heading = (
    <Tag id={id} className={cn(styles.title, 'u-display', 'u-gradient-text')}>
      {title}
    </Tag>
  );

  return (
    <header ref={ref} className={cn(styles.header, styles[align], inView && styles.in, className)}>
      {/* Not `muted`: on alt-toned sections that grey matches the background and
          the chip disappears. White + hairline border reads on both. */}
      {eyebrow && <Pill className={styles.eyebrow}>{eyebrow}</Pill>}

      {actions ? (
        <div className={styles.split}>
          <div>
            {heading}
            {subtitle && <p className={cn(styles.subtitle, 'u-body-lg')} style={{ marginTop: 'var(--space-4)' }}>{subtitle}</p>}
          </div>
          <div className={styles.actions}>{actions}</div>
        </div>
      ) : (
        <>
          {heading}
          {subtitle && <p className={cn(styles.subtitle, 'u-body-lg')}>{subtitle}</p>}
        </>
      )}
    </header>
  );
}
